import { create } from 'zustand'

/**
 * Multi-select for bulk triage (design 13a). Shared across the separately
 * rendered groups of a list, and deliberately not persisted.
 */
type TaskSelectionState = {
  selectedIds: ReadonlySet<string>
  toggle: (id: string) => void
  clear: () => void
}

export const useTaskSelectionStore = create<TaskSelectionState>()((set) => ({
  selectedIds: new Set<string>(),
  toggle: (id) =>
    set((state) => {
      const next = new Set(state.selectedIds)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return { selectedIds: next }
    }),
  clear: () => set({ selectedIds: new Set<string>() }),
}))
